module.exports = __webpack_public_path__ + "img/message.26c05fe0.svg";